import { combine, createStore, Event, sample } from 'effector';
import { persist } from 'effector-storage/local';
import { condition, delay, not } from 'patronum';
import { gameModel } from 'entities/game';
import { VITE_ASSETS_VARIANT } from 'shared/config';
import { createModalSwitcher } from 'shared/lib';

type OnboardingPersisterParams = {
	key: string;
	skip: Event<unknown>;
};

const onboardingSwitcher = createModalSwitcher();

condition({
	source: gameModel.$isOnboarding,
	if: (isOnboarding) => isOnboarding,
	then: onboardingSwitcher.enable,
	else: onboardingSwitcher.disable,
});

const createOnboardingPersister = ({ key, skip }: OnboardingPersisterParams) => {
	const $usernames = createStore<string[]>([]);

	const $passed = combine(
		[gameModel.$username, $usernames],
		([username, usernames]) => username !== null && usernames.includes(username),
	);

	sample({
		clock: skip,
		source: {
			usernames: $usernames,
			username: gameModel.$username,
		},
		filter: ({ usernames, username }) => username !== null && !usernames.includes(username),
		fn: ({ usernames, username }) => [...usernames, username!],
		target: $usernames,
	});

	persist({
		store: $usernames,
		key,
	});

	return $passed;
};

const $beginOnboardingPassed = createOnboardingPersister({
	key: `leprecoins_${VITE_ASSETS_VARIANT}_begin_onboarding`,
	skip: gameModel.skipOnboarding,
});

sample({
	clock: delay(gameModel.loaderClosed, 450),
	filter: not($beginOnboardingPassed),
	fn: () => true,
	target: gameModel.$isOnboarding,
});

export const onboardingModalModel = { onboardingSwitcher };
